import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { STDRISK_INIT_FAIL, STDRISK_INIT_LOADING, STDRISK_INIT_SUCCESS, STDRISK_TEXT_INIT_FAIL, STDRISK_TEXT_INIT_LOADING, STDRISK_TEXT_INIT_SUCCESS, STDRISK_ITEMTEXT_INIT_FAIL, STDRISK_ITEMTEXT_INIT_LOADING, STDRISK_ITEMTEXT_INIT_SUCCESS } from '@/store/types'

export const stdRisk = {
  async stdRiskInit ({ commit, state }) {
    const apiUrl = state.menu.stdRiskTxt
    if (apiUrl) {
      commit(STDRISK_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(STDRISK_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(STDRISK_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(STDRISK_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async stdRiskTextInit ({ commit, state }) {
    const apiUrl = state.stdRisk.menu.initStdRiskTxt
    if (apiUrl) {
      commit(STDRISK_TEXT_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(STDRISK_TEXT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(STDRISK_TEXT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(STDRISK_TEXT_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async stdRiskItemTextInit ({ commit, state }) {
    const apiUrl = state.stdRisk.menu.initStdRiskItemTxt
    if (apiUrl) {
      commit(STDRISK_ITEMTEXT_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(STDRISK_ITEMTEXT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(STDRISK_ITEMTEXT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(STDRISK_ITEMTEXT_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
